<template>
  <div>
    <v-container class="my-7">
      <Banner v-if="sm" type="top" />

      <v-row class="mt-4">
        <v-col cols="12" lg="7" class="mt-4 pr-lg-16" order="12" order-lg="0">
          <Title class="mb-4">Entre em Contato</Title>

          <ContactForm />
        </v-col>

        <v-col cols="12" lg="5" class="mt-4" order="0" order-lg="12">
          <Title>Informações</Title>

          <div class="d-flex flex-column">
            <div
              v-for="({ title, link, icon }, i) in contact"
              :key="i"
              class="d-flex align-center mt-3"
            >
              <v-btn
                :href="link"
                target="_blank"
                color="secondary"
                class="mr-2"
                small
                icon
              >
                <v-icon size="18">{{ icon }}</v-icon>
              </v-btn>
              <a
                class="
                  text-body-2
                  grey--text
                  text--darken-4 text-decoration-none
                "
                :href="link"
                target="_blank"
                >{{ title }}</a
              >
            </div>
          </div>
        </v-col>
      </v-row>
      <Banner type="center-2" class="mt-7" />
    </v-container>
  </div>
</template>

<script>
import Title from "@/components/widgets/Title.vue";
import Banner from "@/components/cards/Banner.vue";
import ContactForm from "@/components/forms/Contact.vue";
import { getSocial, getContact } from "@/config.js";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this);
    },
    contact() {
      return getContact(this);
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    Title,
    Banner,
    ContactForm,
  },
};
</script>
